// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"757":"a768ae14","877":"17dc322a"}[chunkId] + ".chunk.js";
};